import React, { useEffect, useState, useContext } from "react";
import { Grid, Typography, Button, Box, TextField, Input, Autocomplete, Modal, CircularProgress, Skeleton, InputAdornment, IconButton, } from "@mui/material";
import { useTranslation } from "react-i18next";
import AlertMessage from "./modules/AlertMessage";
import { baseUrl } from "./modules/general";
import axios from "axios";
import { Link, NavLink, } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SearchIcon from '@mui/icons-material/Search';


export default function EditProduct() {
  const { t, i18n } = useTranslation();
  const [alert, setAlert] = useState({ alertCheck: false, message: "", severity: "" });
  const [select, setSelect] = useState("");
  const [selectID, setSelectID] = useState(1);
  const [id, setId] = useState("");
  const [group, setGroup] = useState("");
  const [brand, setBrand] = useState("");
  const [btnDis, setBtnDis] = useState(false);
  const [loading, setLoading] = useState(false);
  const [brandData, setBrandData] = useState(null);
  const [groupData, setGroupData] = useState(null);
  const [groupId, setGroupId] = useState("");
  const [brandId, setBrandId] = useState("");
  const [searchData, setSearchData] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [prices, setPrices] = useState({})
  const [searchTerm, setSearchTerm] = useState("");
  const [originalData, setOriginalData] = useState('');

  useEffect(() => {
    const props = ["G", "B"];
    props.forEach(prop => {
      getProductData(prop);
    });
  }, []);

  const getProductData = (prp) => {
    Promise.resolve(axios({
      url: baseUrl + '/api/v1/product/get',
      method: "GET",
      params: {
        prop: prp
      },
    }))
      .then((res) => {
        switch (prp) {
          case ("B"):
            setBrandData(res.data.data)
            break;
          case ("G"):
            setGroupData(res.data.data)
            break;
          default:
            break;
        }
      })
      .catch((error) => {
        const { status } = error.response;
        status === 500 ?
          setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" }) :
          setAlert({ alertCheck: true, message: t("alert_dataFaild"), severity: "error" })
      })
  }

  const options = [
    { label: i18n.language === "fa" ? "شماره شناسه" : "ID", id: 1 },
    { label: i18n.language === "fa" ? 'گروه یا برند' : "Group or Brand", id: 2 },
  ];

  const brandSelect = brandData === null ? [] : brandData.map((item) => (
    {
      value: i18n.language === "fa" ? item.name_fa : item.en,
      id: item.id
    }
  ))

  const groupSelect = groupData === null ? [] : groupData.map((item) => (
    {
      value: i18n.language === "fa" ? item.name_fa : item.en,
      id: item.id
    }
  ))

  const onchangeSelection = (event, newSelection) => {
    setSelect(newSelection);
    setSelectID(newSelection.id);
    setId("");
    setGroup("");
    setBrand("");
  }

  const onchangeGroup = (event, newSelection) => {
    setGroup(newSelection);
    setGroupId(newSelection ? newSelection.id : '')
    setBrand("");
    setBrandId("")
    setSearchTerm("")
  }

  const onchangeBrand = (event, newSelection) => {
    setBrand(newSelection);
    setBrandId(newSelection ? newSelection.id : '')
  }

  const errorHandler = () => {
    if (selectID === 1) {
      if (id === "") {
        setAlert({ alertCheck: true, message: "موارد خواسته شده را وارد کنید.", severity: "error" })
      }
      else {
        searchProduct()
      }
    }
    else {
      if (group === "" && brand === "") {
        setAlert({ alertCheck: true, message: "موارد خواسته شده را وارد کنید.", severity: "error" })
      }
      else {
        searchProduct()
      }
    }
  }

  const searchProduct = () => {
    setLoading(true);
    setBtnDis(true);
    let params = { prop: "P" };
    if (selectID === 1 && id) {
      params.id = id;
    } else {
      if (brandId) {
        params.brand = brandId;
      }
      if (groupId) {
        params.group = groupId;
      }
    }
    Promise.resolve(axios({
      url: baseUrl + '/api/v1/product/get',
      method: "GET",
      params: params,
    }))
      .then((res) => {
        setLoading(false);
        setBtnDis(false);
        setSearchData(res.data.data);
        setOriginalData(res.data.data);
        setSearchTerm("");
      })
      .catch((error) => {
        setLoading(false);
        setBtnDis(false);
        const { status } = error.response;
        status === 500 ?
          setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" }) :
          setAlert({ alertCheck: true, message: t("alert_dataFaild"), severity: "error" })
      })
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    return setAlert({ alertCheck: false, message: "", severity: alert.severity })
  };

  const replaceNumber = (value, la) => {
    value = value ? value.toString() : '';
    if (la === "fa") {
      value = value.replace(".", "/");
    }
    return value;
  }

  const separator = (value) => {
    value = value ? value.toString() : '';
    var place = 0;
    if (value.includes(".")) {
      place = value.indexOf(".");
      var num1 = value.slice(0, place);
      var num2 = value.slice(place + 1, value.length);
      value = camaInsert(num1, false) + "." + camaInsert(num2, true);
    }
    else {
      value = camaInsert(value);
    }
    return value;
  }

  function camaInsert(value, after = false) {
    var output = [];
    var outputString = "";
    if (after) {
      for (var i = 1; i <= value.length; i++) {
        if (i % 3 === 0) {
          output.push(value.slice(i - 3, i))
        }
      }
      if (value.length % 3 !== 0) {
        output.push(value.slice(value.length - value.length % 3, value.length))
      }

      for (var j = 0; j < output.length; j++) {
        if (j + 1 < output.length) {
          outputString = outputString + output[j] + ",";
        }
        else {
          outputString = outputString + output[j];
        }
      }
    }
    else {
      for (var p = 1; p <= value.length; p++) {
        if (p % 3 === 0) {
          output.push(value.slice(value.length - p, value.length - p + 3))
        }
      }
      if (value.length % 3 !== 0) {
        output.push(value.slice(0, value.length % 3))
      }
      for (var o = output.length - 1; o >= 0; o--) {
        if (o > 0) {
          outputString = outputString + output[o] + ",";
        }
        else {
          outputString = outputString + output[o];
        }
      }
    }
    return outputString;
  }

  const stringValue = (value) => {
    var output = "";
    value = value.toString();
    value = value.split(",");
    for (var i = 0; i < value.length; i++) {
      output += value[i].toString();
    }
    output = output.replace("/", ".");
    return output;
  }

  const onlyFloatnaumber = (value) => {
    value = value.trim();
    value = stringValue(value);
    var regex = new RegExp("^[0-9]*[.]*[0-9]*$");
    if (regex.test(value)) {
      if (value[0] !== '0') {
        return value;
      }
      else {
        if (value.length === 1) {
          return value;
        }
        else {
          if (value.length === 2) {
            if (value[0] === '0' && value[1] === '.') {
              return value;
            }
            else {
              if (value[0] === '0' && value[1] !== '.') {
                return value[1];
              }
            }
          }
          else {
            if (value.length > 2) {
              if (value.substr(2).includes('.')) {
                return value[0] + value[1];
              }
              else {
                return value;
              }
            }
          }
        }
      }
    }
    else {
      return '';
    }
  }

  const searchContent = () => {
    let result = [];
    if (searchData === null) {
      result.push(
        <Skeleton key={"data3"} variant="rounded" animation="wave" sx={{ width: { xs: "95%", lg: "90%" }, height: "50px", marginTop: "1em" }} />
      )
    }
    else if (Array.isArray(searchData) && searchData.length === 0) {
      result.push(
        <Typography sx={{ marginTop: "1em" }}>موردی یافت نشد</Typography>
      )
    }
    else if (Array.isArray(searchData) && searchData.length !== 0) {
      searchData.forEach((item, i) => {
        const myPath = item.group.id === 1 ? "MobilePhonePriceList" : item.group.id === 2 ? "LaptopPriceList" : item.group.id === 3 ? "TabletPriceList" : item.group.id === 4 ? "GameConsolePriceList" : item.group.id === 6 ? "GameControllerPriceList" : item.group.id === 7 && "ModemPriceList"
        result.push(
          <Grid key={i} sx={{
            width: "95%", flexDirection: "row", display: "flex", height: "50px", boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "15px",
            marginTop: "1em", alignItems: "center", backgroundColor: "white"
          }}>
            <Grid sx={{ width: { md: "12%", lg: "15%" }, justifyContent: "center", alignItems: "center", display: "flex" }}>
              <Typography sx={{ fontSize: { md: "8px", lg: "9px", xl: "13px" } }}>{item.model.name}</Typography>
            </Grid>
            <Grid sx={{ width: { md: "7%", lg: "6%" }, justifyContent: "center", alignItems: "center", display: "flex" }}>
              <Typography sx={{ fontSize: { md: "8px", lg: "9px", xl: "13px" } }}>{item.id}</Typography>
            </Grid>
            <Grid sx={{ width: { md: "7%", lg: "6%" }, justifyContent: "center", alignItems: "center", display: "flex" }}>
              <Typography sx={{ fontSize: { md: "8px", lg: "9px", xl: "13px" } }}>{separator(item.price)}</Typography>
            </Grid>
            <Grid sx={{ width: { md: "7%", lg: "6%" }, justifyContent: "center", alignItems: "center", display: "flex" }}>
              <Typography sx={{ fontSize: { md: "7px", lg: "9px", xl: "12px", textAlign: "center" } }}>{item.color.name_fa}</Typography>
            </Grid>
            <Grid sx={{ width: { md: "7%", lg: "6%" }, justifyContent: "center", alignItems: "center", display: "flex" }}>
              <Typography sx={{ fontSize: { md: "7px", lg: "9px", xl: "13px", textAlign: "center" } }}>{item.hdd}</Typography>
            </Grid>
            <Grid sx={{ width: { md: "7%", lg: "6%" }, justifyContent: "center", alignItems: "center", display: "flex" }}>
              <Typography sx={{ fontSize: { md: "7px", lg: "9px", xl: "13px", textAlign: "center" } }}>{item.ram}</Typography>
            </Grid>
            <Grid sx={{ width: { md: "7%", lg: "6%" }, justifyContent: "center", alignItems: "center", display: "flex" }}>
              <Typography sx={{ fontSize: { md: "7px", lg: "9px", xl: "13px" } }}>{item.regin.name_fa}</Typography>
            </Grid>
            <Grid sx={{ width: { md: "13.5%", lg: "12%", xl: "12%" }, justifyContent: "center", alignItems: "center", display: "flex" }}>
              <Link style={{ textDecoration: 'none' }} target="_blank" to={`/EditProductFeatures/Features/${item.id}`}>
                <Button sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0px 2px",
                  "&:hover": { backgroundColor: "#F5AD51" },
                  backgroundColor: "#F5AD51",
                  width: { md: "30px", lg: "80px", xl: "120px" },
                  height: { md: "28px", lg: "35px" },
                  borderRadius: "25px"
                }}>
                  <Typography component={"p"} sx={{
                    color: "white",
                    fontSize: { md: "7px", lg: "10px", xl: "15px" },
                    fontWeight: "bold"
                  }}>
                    ویرایش متن
                  </Typography>
                </Button>
              </Link>
            </Grid>
            <Grid sx={{ width: { md: "13.5%", lg: "12%", xl: "12%" }, justifyContent: "center", alignItems: "center", display: "flex" }}>
              <Link style={{ textDecoration: 'none' }}
                to={`/EditProductFeatures/Images/${item.id}`}
                target="_blank"
              >
                <Button sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0px 2px",
                  "&:hover": { backgroundColor: "#F58D7A" },
                  backgroundColor: "#F58D7A",
                  width: { md: "30px", lg: "80px", xl: "120px" },
                  height: { md: "28px", lg: "35px" },
                  borderRadius: "25px"
                }}>
                  <Typography component={"p"} sx={{
                    color: "white",
                    fontSize: { md: "7px", lg: "10px", xl: "15px" },
                    fontWeight: "bold"
                  }}>
                    ویرایش عکس
                  </Typography>
                </Button>
              </Link>
            </Grid>
            <TextField
              size="small"
              placeholder="ثبت قیمت جدید"
              className="textField"
              variant='outlined'
              fullWidth
              value={replaceNumber(separator(prices[item.id]), i18n.language) || ''}
              onChange={(e) => {
                const newValue = onlyFloatnaumber(e.target.value);
                setPrices({
                  ...prices,
                  [item.id]: onlyFloatnaumber(newValue)
                });
              }}
              sx={{
                width: { md: "90px", lg: "110px", xl: "250px" }, background: "#FFFFFF",
                boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px", margin: "0px 5px 0px 5px",
                '& .MuiInputBase-input': {
                  fontSize: {
                    md: '10px',
                    lg: '12px',
                    xl: '18px',
                  },
                },
                ' & .MuiInputBase-input::placeholder': {
                  fontSize: {
                    md: '10px',
                    lg: '12px',
                    xl: '18px',
                  }
                },
              }}
            />
            <Grid sx={{ width: { md: "13.5%", lg: "12%", xl: "12%" }, justifyContent: "center", alignItems: "center", display: "flex" }}>
              <Button disabled={btnDis} onClick={() => priceHandler(item.id)}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0px 2px",
                  "&:hover": { backgroundColor: "#35DB35" },
                  backgroundColor: "#35DB35",
                  width: { md: "20px", lg: "80px", xl: "120px" },
                  height: { md: "28px", lg: "35px" },
                  borderRadius: "25px"
                }}>
                <Typography component={"p"} sx={{
                  color: "white",
                  fontSize: { md: "7px", lg: "10px", xl: "15px" },
                  fontWeight: "bold"
                }}>
                  {btnDis === true && loading === true ? <CircularProgress size={20} color="inherit" sx={{ color: "white" }} /> : 'ثبت قیمت'}
                </Typography>
              </Button>
            </Grid>
            <NavLink target="_blank" to={`/${myPath}/${item.id}/${item.brand.name_en}${item.model.name}`} className="navlink" style={{
              display: "flex", alignItems: "center", flexDirection: "row", justifyContent: "center", textAlign: "center", color: "black"
            }}>
              <VisibilityIcon sx={{ padding: "0px 2px 0px 5px" }} />
            </NavLink>
          </Grid>
        )
      })
    }
    return result;
  }

  const priceHandler = (proId) => {
    const priceValue = prices[proId] || "";
    if (priceValue.trim() === "") {
      setAlert({ alertCheck: true, message: "قیمت را وارد کنید.", severity: "error" });
    } else {
      submitPrice(proId);
    }
  }

  const submitPrice = (proId) => {
    setBtnDis(true);
    setLoading(true);
    const AuthStr = 'Bearer ' + (localStorage.getItem('TACC'));
    Promise.resolve(axios({
      url: baseUrl + '/api/v1/product/edit',
      method: "POST",
      headers: {
        'Authorization': AuthStr,
      },
      data: {
        price: prices[proId],
        prop: "PP",
        id: proId
      }
    }))
      .then((res) => {
        setLoading(false);
        setBtnDis(false);
        setAlert({ alertCheck: true, message: "قیمت جدید ثبت شد", severity: "success" });
      })
      .catch(
        (error) => {
          const { status } = error.response;
          switch (status) {
            case (500):
              setAlert({ alertCheck: true, message: t("AM_intervalServer"), severity: "error" })
              break;
            case (400):
              setAlert({ alertCheck: true, message: "درخواست نامعتبر است،لطفا فیلدها را مجددا چک کنید", severity: "error" })
              break;
            default:
              setAlert({ alertCheck: true, message: t("alert_defualt"), severity: "error" })
          }
          setBtnDis(false)
          setLoading(false)
        })
  }

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
    const val = event.target.value
    if (val === "") {
      setSearchData(originalData);
    } else {
      const filtered = originalData.filter(item =>
        item.model.name.toLowerCase().includes(val.toLowerCase())
      );
      setSearchData(filtered);
    }
  };

  return (
    <>
      <Grid sx={{
        display: 'flex', width: "100%", height: "100%", flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        direction: i18n.language === "fa" ? "rtl" : 'ltr'
      }}>
        <Grid sx={{ display: "flex", flexDirection: { xs: "column", md: "row", }, width: "100%", justifyContent: { xs: "unset", md: "space-evenly" }, alignItems: { xs: "center", md: "unset" } }}>
          <Grid style={{ display: "flex", alignItems: "center" }}>
            <Autocomplete
              value={select}
              onChange={onchangeSelection}
              options={options}
              getOptionLabel={(option) => option ? option.label || '' : ''}
              renderOption={(props, option) => (
                <Typography component={"li"} {...props}>
                  {option.label}
                </Typography>
              )}
              size="medium"
              sx={{
                width: { xs: "200px", sm: "350px", md: "200px", lg: "300px", xl: "500px" }, "& .MuiInputBase-root fieldset": { borderRadius: "14px" }, backgroundColor: "white", borderRadius: "14px"
                , "& .MuiAutocomplete-endAdornment": { left: i18n.language === "fa" ? "7px !important" : "unset !important", right: i18n.language === "fa" ? "unset !important" : "7px !important" }
                , "& .MuiMenuItem-root": { justifyContent: "flex-end" }, "& .MuiSvgIcon-root": { color: "text.greenLight" }
              }}
              renderInput={(params) =>
                <TextField
                  className="textField"
                  label="جستجو بر اساس ..."
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                  }}
                />}
              isOptionEqualToValue={(option, value) => {
                if (!value) return false;
                return option.id === value.id;
              }}
            />
          </Grid>
          {
            selectID === 1 ?
              <Grid sx={{ marginTop: { xs: "1em", md: "unset" }, display: "flex", flexDirection: { xs: "column", md: "row", }, width: "50%", justifyContent: { xs: "unset", md: i18n.language === "fa" ? "flex-end" : "flex-start" }, alignItems: { xs: "center", md: "unset" } }}>
                <TextField placeholder="شماره شناسه"
                  className="textField"
                  variant='outlined'
                  fullWidth
                  value={id}
                  type="number"
                  onChange={(e) => setId(e.target.value)}
                  sx={{
                    width: { xs: "200px", sm: "350px", md: "220px", lg: "80%", xl: "70%" }, background: "#FFFFFF",
                    boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.25)", borderRadius: "8px",
                  }}
                />
              </Grid>
              :
              selectID === 2 ?
                <Grid sx={{ marginTop: { xs: "1em", md: "unset" }, display: "flex", flexDirection: { xs: "column", md: "row", }, width: "60%", justifyContent: { xs: "unset", md: "space-evenly", lg: "space-between" }, alignItems: { xs: "center", md: "unset" } }}>
                  <Grid style={{ display: "flex", alignItems: "center" }}>
                    <Autocomplete
                      value={group}
                      onChange={onchangeGroup}
                      options={groupSelect}
                      getOptionLabel={(option) => option ? option.value || '' : ''}
                      renderOption={(props, option) => (
                        <Typography component={"li"} {...props}>
                          {option.value}
                        </Typography>
                      )}
                      size="medium"
                      sx={{
                        width: { xs: "200px", sm: "350px", md: "150px", lg: "235px", xl: "450px" }, "& .MuiInputBase-root fieldset": { borderRadius: "14px" }, backgroundColor: "white", borderRadius: "14px"
                        , "& .MuiAutocomplete-endAdornment": { left: i18n.language === "fa" ? "7px !important" : "unset !important", right: i18n.language === "fa" ? "unset !important" : "7px !important" }
                        , "& .MuiMenuItem-root": { justifyContent: "flex-end" }, "& .MuiSvgIcon-root": { color: "text.greenLight" }
                      }}
                      renderInput={(params) =>
                        <TextField
                          className="textField"
                          label="انتخاب دسته"
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            type: 'search',
                          }}
                        />}
                      isOptionEqualToValue={(option, value) => {
                        if (!value) return false;
                        return option.id === value.id;
                      }}
                    />
                  </Grid>
                  <Grid sx={{ display: "flex", alignItems: "center", marginTop: { xs: "10px", md: "unset" } }}>
                    <Autocomplete
                      value={brand}
                      onChange={onchangeBrand}
                      options={brandSelect}
                      getOptionLabel={(option) => option ? option.value || '' : ''}
                      renderOption={(props, option) => (
                        <Typography component={"li"} {...props}>
                          {option.value}
                        </Typography>
                      )}
                      size="medium"
                      sx={{
                        width: { xs: "200px", sm: "350px", md: "150px", lg: "235px", xl: "450px" }, "& .MuiInputBase-root fieldset": { borderRadius: "14px" }, backgroundColor: "white", borderRadius: "14px"
                        , "& .MuiAutocomplete-endAdornment": { left: i18n.language === "fa" ? "7px !important" : "unset !important", right: i18n.language === "fa" ? "unset !important" : "7px !important" }
                        , "& .MuiMenuItem-root": { justifyContent: "flex-end" }, "& .MuiSvgIcon-root": { color: "text.greenLight" }
                      }}
                      renderInput={(params) =>
                        <TextField
                          className="textField"
                          label="انتخاب برند"
                          {...params}
                          InputProps={{
                            ...params.InputProps,
                            type: 'search',
                          }}
                        />}
                      isOptionEqualToValue={(option, value) => {
                        if (!value) return false;
                        return option.id === value.id;
                      }}
                    />
                  </Grid>
                </Grid>
                : null
          }
        </Grid>
        <Grid sx={{ display: "flex", width: "100%", justifyContent: "center" }}>
          <Button disabled={btnDis} onClick={errorHandler} sx={{
            display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", padding: "0px 2px", marginTop: { xs: "2em", md: "4em" },
            "&:hover": { backgroundColor: "#FF3951" }, backgroundColor: "#FF3951", width: { xs: "100px", md: "200px" }, height: { xs: "35px", md: "50px" }, borderRadius: "25px"
          }} >
            <Typography component={"p"} sx={{ color: "white", fontSize: "17px", fontWeight: "bold" }}>
              {btnDis === true && loading === true ? <CircularProgress size={20} color="inherit" sx={{ color: "white" }} /> : 'جستجو'}
            </Typography>
          </Button>
        </Grid>
        <Grid sx={{ width: "100%", display: "flex", justifyContent: "center", flexDirection: "column", }}>
          <Grid sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <Grid sx={{
              width: "40%", display: Array.isArray(searchData) && searchData.length !== 0 ? "flex" : "none", justifyContent: "space-between",
              marginRight: { xl: "7em", md: "3em", lg: "4.5em" }, marginTop: "1em",
            }}>
              <Grid sx={{ width: { md: "12%", lg: "15%" }, alignItems: "center", justifyContent: "center", display: "flex", }}>
                <Typography sx={{ fontSize: { md: "7px", lg: "12px", xl: "18px" }, color: "purple", fontWeight: 600 }}>مدل</Typography>
              </Grid>
              <Grid sx={{ width: "6%", alignItems: "center", justifyContent: "center", display: "flex", }}>
                <Typography sx={{ fontSize: { md: "7px", lg: "12px", xl: "18px" }, color: "purple", fontWeight: 600 }}>شناسه</Typography>
              </Grid>
              <Grid sx={{ width: "6%", alignItems: "center", justifyContent: "center", display: "flex", }}>
                <Typography sx={{ fontSize: { md: "7px", lg: "12px", xl: "18px" }, color: "purple", fontWeight: 600 }}>قیمت</Typography>
              </Grid>
              <Grid sx={{ width: "6%", alignItems: "center", justifyContent: "center", display: "flex", }}>
                <Typography sx={{ fontSize: { md: "7px", lg: "12px", xl: "18px" }, color: "purple", fontWeight: 600 }}>رنگ</Typography>
              </Grid>
              <Grid sx={{ width: "6%", alignItems: "center", justifyContent: "center", display: "flex", }}>
                <Typography sx={{ fontSize: { md: "7px", lg: "12px", xl: "18px" }, color: "purple", fontWeight: 600 }}>ظرفیت</Typography>
              </Grid>
              <Grid sx={{ width: "6%", alignItems: "center", justifyContent: "center", display: "flex", }}>
                <Typography sx={{ fontSize: { md: "7px", lg: "12px", xl: "18px" }, color: "purple", fontWeight: 600 }}>رم</Typography>
              </Grid>
              <Grid sx={{ width: "6%", alignItems: "center", justifyContent: "center", display: "flex", }}>
                <Typography sx={{ fontSize: { md: "7px", lg: "12px", xl: "18px" }, color: "purple", fontWeight: 600 }}>کشور</Typography>
              </Grid>
            </Grid>
            <Grid sx={{ width: '50%', justifyContent: "center", display: "flex" }}>
              <TextField
                variant="outlined"
                placeholder={t("search")}
                value={searchTerm}
                size="small"
                onChange={handleChange}
                // onKeyPress={handleKeyPress}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton aria-label="search">
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  width: { md: "70%", },
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '20px', boxShadow: "2px 2px 10px #FF3951", border: "unset", display: searchData ? "flex" : "none"
                  },
                  marginTop: "1em"
                }}
              />
            </Grid>
          </Grid>

          <Grid sx={{ width: "100%", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
            {searchContent()}
          </Grid>
        </Grid>

        <AlertMessage open={alert.alertCheck} message={alert.message} duration={3000} close={handleClose} severity={alert.severity} />
      </Grid>
    </>
  )
}